import apiClient from './client';
import type {
  AppConfiguration,
  BudgetAllocationRequest,
  BudgetAllocationResponse,
  ManualBudgetUpdateRequest,
  ManualBudgetUpdateResponse,
  ManualNameUpdateRequest,
  ManualNameUpdateResponse,
  ColdStartOptimizationRequest,
  ColdStartOptimizationResponse
} from '@/types/api';

export const optimizationApi = {
  async runColdstartOptimization(params: ColdStartOptimizationRequest): Promise<ColdStartOptimizationResponse> {
    const response = await apiClient.post<ColdStartOptimizationResponse>('/optimization/coldstart', params);
    return response.data;
  },

  async runBudgetAllocation(params: BudgetAllocationRequest): Promise<BudgetAllocationResponse> {
    const response = await apiClient.post<BudgetAllocationResponse>('/optimization/budget-allocation', params);
    return response.data;
  },

  async updateManualBudgets(params: ManualBudgetUpdateRequest): Promise<ManualBudgetUpdateResponse> {
    const response = await apiClient.post<ManualBudgetUpdateResponse>('/optimization/manual-budget-update', params);
    return response.data;
  },

  async updateManualNames(params: ManualNameUpdateRequest): Promise<ManualNameUpdateResponse> {
    const response = await apiClient.post<ManualNameUpdateResponse>('/optimization/manual-name-update', params);
    return response.data;
  },

  async saveConfiguration(config: AppConfiguration): Promise<void> {
    await apiClient.put('/app-configuration/update', config);
  },

  async loadConfiguration(memberUuid: string): Promise<AppConfiguration> {
    const response = await apiClient.get<AppConfiguration>(`/app-configuration/saved/${memberUuid}`);
    return response.data;
  },

  async loadFreshConfiguration(memberUuid: string): Promise<AppConfiguration> {
    const response = await apiClient.get<AppConfiguration>(`/app-configuration/fresh/${memberUuid}`);
    return response.data;
  },

  async loadGoogleAdsConfiguration(memberUuid: string, daysBack: number = 30, saveToDb: boolean = false): Promise<AppConfiguration> {
    const response = await apiClient.get<AppConfiguration>(`/app-configuration/google-ads/${memberUuid}`, {
      params: {
        days_back: daysBack,
        save_to_db: saveToDb
      }
    });
    return response.data;
  },
};